import { useSearchConversationIdsQuery } from 'generated-graphql/hooks/apollo-hooks';
import {
  ConversationStatus,
  SearchableConversationSortableFields,
  SearchableSortDirection
} from 'generated-graphql/types';
import { schedulingSatisfiedFilter } from 'modules/conversations/constants';
import { CampaignType } from 'services/campaign/types';

const acceptedStatusFilter = {
  or: [
    { status: { eq: ConversationStatus.CompletedMeetingRequested } },
    { status: { eq: ConversationStatus.CompletedAwaitingCall } },
    { status: { eq: ConversationStatus.CompletedCustomRequest } }
  ]
};

export const useSatisfiedConversationCount = (
  campaignId: string,
  campaignType?: CampaignType | null
) => {
  const { data, loading } = useSearchConversationIdsQuery({
    variables: {
      filter: {
        campaignId: { eq: campaignId },
        ...(campaignType === CampaignType.SCHEDULING
          ? schedulingSatisfiedFilter
          : acceptedStatusFilter)
      },
      sort: {
        field: SearchableConversationSortableFields.UpdatedAt,
        direction: SearchableSortDirection.Desc
      },
      from: 0,
      limit: 1
    },
    skip: !campaignId
  });

  return { count: data?.searchConversations?.total ?? 0, loading };
};
